export default __webpack_public_path__ + "static/media/ModRobV1.32e96dc7.png";